import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-146" data-mp="k2933jkeemuh">
      <span className="font-display text-lg font-black tabular-nums text-white sm:text-xl" data-id="element-147" data-mp="k3smhj1cpe0h">{String(value).padStart(2, '0')}</span>
      <span className="text-[10px] font-semibold uppercase tracking-widest text-white/60" data-id="element-148" data-mp="abmwgeunt6nx">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 border-b border-gold/25 bg-navy-deep text-white" data-id="element-149" data-mp="1brhdyxzgrim">
      <div className="mx-auto flex h-11 max-w-5xl items-center justify-center gap-4 px-4" data-id="element-150" data-mp="r1envomqyyon">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-white/75 sm:text-xs" data-id="element-151" data-mp="mxgodctiflv2">
          <HourglassIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-152" data-mp="vyetjyfopzf8" />
          Offer expires in:
        </p>
        <p className="flex items-baseline gap-1.5" aria-live="off" data-id="element-153" data-mp="88arhvi5a7qc">
          <Unit value={mm} label="Min" data-id="element-154" data-mp="86hgk40i11cj" />
          <span className="font-black text-gold" data-id="element-155" data-mp="3aiqmbzivba0">:</span>
          <Unit value={ss} label="Sec" data-id="element-156" data-mp="37whi7wzgnpo" />
        </p>
      </div>
    </div>;
}